import devConsole from './devConsole';

export default function logError(errorMessage: string) {
  devConsole.error(errorMessage);
  throw new Error(errorMessage);
}
